import React, { useEffect, useRef } from "react";
import Button from "./Button";
import lottie from "lottie-web";
import ParaText from "./ParaText";
import SectionTitle from "./SectionTitle";


export default function AboutSection() {
  const containers = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: containers.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../assets/images/hackerboy.json"),
    });
  });

  return (
    <div>
      <div className="aboutsection">
        <div className=" aboutSection__left">
          <SectionTitle
            className="section-title"
            subheading="Let Me Introduce Myself"
            heading="About me"
          />
          <ParaText className="aboutsection__paraText">
          I am a Fullstack Developer from Lagos.
          <br/>Got a Philia for Snow, Movies, Technology and Gaming (and also teslas🤫)...
          </ParaText>
          <div className="aboutSection_Button">
            <Button btnLink="/project" btnText="works" outline="#f33501" />
            <Button btnLink="/about" btnText="Read More" />
          </div>
        </div>
        <div className="aboutsection_right">
          {/* <img src={AboutImg} alt="" /> */}
          <div className="containers" ref={containers}></div>
        </div>
      </div>
    </div>
  );
}
